import {
  CLIENT_ID_KEY,
  RETURN_URL_KEY
} from '../../constants/queryParameters'

export const login = ({ loginLocation, clientId, returnURL }) => {
  const queryParams = {
    [CLIENT_ID_KEY]: clientId,
    [RETURN_URL_KEY]: returnURL
  }

  const searchParams = new URLSearchParams(queryParams)
  const querystring = searchParams.toString()

  window.location.href = `${loginLocation}?${querystring}/`
}
